import React from 'react';

import { EAbilitySubjects } from '@client/hooks/useAbilities';
import { PageLayout } from '@client/layouts/page.layout';

export const DashboardPage: React.FC = () => (
  <PageLayout subject={`${EAbilitySubjects.DASHBOARD}`} title="Dashboard">
    <h1>Welcome to the Dash Page</h1>
    <p>This is the main landing page of our application.</p>
  </PageLayout>
);
